import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingContinents = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CONTINENT}`, "get");
    const body = await resp.json();

    debugLogActions(':: catalogContinentActions, startLoadingContinents', { 'body': body });

    if (body.ok) {
      dispatch(loadingContinents(body.continents));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingContinents = (continents) => ({
  type: types.CONTINENT_START_LOADING,
  payload: continents,
});

export const startLoadingContinentsPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CONTINENT}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: catalogContinentActions, startLoadingContinentsPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingContinentsPaginated(body.continentPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingContinentsPaginated = (continentPaginated) => ({
  type: types.CONTINENT_START_LOADING_PAGINATED,
  payload: continentPaginated,
});

export const selectContinents = (continent) => ({
  type: types.CONTINENT_SELECT,
  payload: continent,
});

export const continentClean = () => ({
  type: types.CONTINENT_CLEAN,
});

export const continentStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CONTINENT}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: catalogContinentActions, continentStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(continentDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogContinentActions, continentStartDelete', { 'error': error });
    }
  };
};

const continentDeleted = (id) => {
  return {
    type: types.CONTINENT_DELETE,
    payload: id,
  };
};

export const startSearchingContinentsPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CONTINENT}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

     debugLogActions(':: catalogContinentActions, startSearchingContinentPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingContinentsPaginated(body.continentsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingContinentsPaginated = (continentsPaginated) => ({
  type: types.CONTINENT_START_SEARCH_PAGINATED,
  payload: continentsPaginated,
});

export const cleanSearchingContinentsPaginated = () => ({
  type: types.CONTINENT_CLEAN_SEARCH_PAGINATED,
});

export const continentStartUpdate = (continent, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CONTINENT}`,
        `update/${continent.id}`,
        continent,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: catalogContinentActions, continentStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(continentUpdated(continent));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-continent");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogContinentActions, continentStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} continent
 * @returns
 */
const continentUpdated = (continent) => {
  return {
    type: types.CONTINENT_UPDATE,
    payload: continent,
  };
};

export const continentStartRegister = (continent, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CONTINENT}`,
      "add",
      continent,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: catalogContinentActions, continentStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(continentRegister(body.continent));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-continent");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const continentRegister = (continent) => ({
  type: types.CONTINENT_START_REGISTER,
  payload: continent,
});

export const continentSetSearchText = (searchText) => ({
  type: types.CONTINENT_SET_SEARCH_TEXT,
  payload: searchText,
});

export const continentCleanSearchText = () => ({
  type: types.CONTINENT_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingContinentsAll = (type) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CONTINENT}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingContinentAll(body.continents));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingContinentAll = (continents) => ({
  type: types.CONTINENT_START_LOADING_ALL,
  payload: continents,
});
